module.exports = __webpack_public_path__ + "img/brand-25.f07a5d18.png";